import React from "react";
import { FieldArray } from "formik";
import FormikController from "./FormikController";
import cn from "clsx";

const FormFieldComponent = ({
  formConfig,
  values,
  errors,
  touched,
  style = undefined,
}) => {
  const dynamicFields = (args) => {
    const { name: keyName, defaultValues, fields } = args;
    return (
      <div
        className="flex flex-col justify-start items-start w-full"
        key={keyName}
      >
        <FieldArray name={keyName}>
          {(arrayHelpers) => {
            return (
              <>
                {(values[keyName] || []).map((value, index) => {
                  return (
                    <div
                      className="flex justify-start mb-6 items-start w-full"
                      key={index}
                    >
                      {fields.map(({ label, name, ...rest }, i) => {
                        return (
                          <FormikController
                            key={i}
                            {...(index === 0 ? { label: label } : {})}
                            name={`${keyName}.${index}.${name}`}
                            {...rest}
                            errors={
                              errors?.[keyName] ? errors[keyName][index] : {}
                            }
                            touched={
                              touched?.[keyName] ? touched[keyName][index] : {}
                            }
                            values={
                              values?.[keyName] ? values[keyName][index] : {}
                            }
                            indexOfField={index}
                          />
                        );
                      })}
                      {index === 0 && values[keyName].length > 1 ? (
                        <div className="flex items-center self-center justify-end gap-2">
                          <button
                            className="self-end"
                            type="button"
                            onClick={() => arrayHelpers.remove(index)}
                          >
                            <i className="fa-solid fa-xmark cursor-pointer"></i>
                          </button>
                          <button
                            type="button"
                            className="flex items-center gap-2 self-center mt-6 ml-4"
                            onClick={() => {
                              arrayHelpers.push({ ...defaultValues });
                            }}
                          >
                            <i className="fa-solid fa-circle-plus text-xl"></i>
                            <span>Add New Row</span>
                          </button>
                        </div>
                      ) : index === 0 && values[keyName].length < 2 ? (
                        <button
                          type="button"
                          className="flex items-center gap-2 self-center mt-6 ml-4"
                          onClick={() => {
                            arrayHelpers.push({ ...defaultValues });
                          }}
                        >
                          <i className="fa-solid fa-circle-plus text-xl"></i>
                          <span>Add New Row</span>
                        </button>
                      ) : (
                        <button
                          className="self-center"
                          type="button"
                          onClick={() => arrayHelpers.remove(index)}
                        >
                          <i className="fa-solid fa-xmark cursor-pointer"></i>
                        </button>
                      )}
                    </div>
                  );
                })}
              </>
            );
          }}
        </FieldArray>
      </div>
    );
  };

  return (
    <>
      {(formConfig || []).map((fields, i) => {
        return (
          <div
            className={cn("flex justify-start mb-6 items-start", {
              "w-full": !style,
            })}
            style={style}
            key={i}
          >
            {fields.map((field, index) => {
              if (field.type === "dynamicField") {
                return dynamicFields({
                  ...field,
                });
              } else {
                return (
                  <FormikController
                    key={index}
                    errors={errors}
                    touched={touched}
                    values={values}
                    {...field}
                  />
                );
              }
            })}
          </div>
        );
      })}
    </>
  );
};
export default FormFieldComponent;
